export const padNumber = (number: number, totalSize: number) => {
    let num = number.toString();

    while (num.length < totalSize) num = `0${num}`;

    return num;
};
